










import { Component as NodeComponent } from 'vue'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { SetProductPageParams } from '@/types/newPersion'
import InputPage from '@/views/newPension/productCard/inputPage/index.vue'
import SettingPage from '@/views/newPension/productCard/setting/index.vue'
import OutputPage from '@/views/newPension/productCard/outputPage/index.vue'
import ProductCfg from '@/views/newPension/pensionCard/lifeProduct/config'
@Component({
  components: {
    InputPage,
    OutputPage,
    SettingPage,
  },
})
export default class extends Vue {
  @Prop() type!: string | null;
  @Prop() tabInfo!: {};
  @Prop() getTopChartAndTableFn!: Function;
  productCfg = ProductCfg;
  page: NodeComponent = InputPage;
  editParams: SetProductPageParams | null = null;

  // 检测父组件状态(切换状态 或者 点击添加按钮)
  @Watch('type')
  handleChangeType (type: string | null) {
    let _type = ''
    if (type) {
      _type = type
    } else {
      _type = 'input'
    }
    this.handleClick(_type)
  }

  created () {
    if (this.type) {
      this.handleClick(this.type)
    }
  }

  handleClick (type: string, params: SetProductPageParams | null = null) {
    switch (type) {
      case 'output':
        this.page = OutputPage
        break
      case 'setting':
        this.handleSetting(params)
        break
      case 'input':
      default:
        this.page = InputPage
        break
    }
  }

  handleSetting (editParams: SetProductPageParams | null = null) {
    // this.page = SettingPage
    // if (params) {
    //   this.editParams = params
    // } else {
    //   this.editParams = null
    // }
    this.$emit('on-add-setting-page', SettingPage, {
      proCfg: this.productCfg,
      editParams,
    })
  }

  private handleEditBtn (status: string, idx: number) {
    this.getTopChartAndTableFn()
    this.$emit('on-edit-btn', status, idx)
  }
}
